exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown {\n  min-width: 0;\n  max-height: 170px;\n}\n", ""]);

// exports
